module.exports = __webpack_public_path__ + "static/media/teri-altered.c56cb0cc.png";